/* ------------------------------------------------------------------------ */
/*		File: apiLoader.tsx                                                 */
/*		Description: Hook to call API services                              */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

import axios from 'axios'
interface Headers {
    [key: string]: string;
}

/* ******************************************************************** */
/* Function: apiLoader                                                  */
/* Description: Call to the API given as parameter                      */
/* ******************************************************************** */

export const apiLoader = async (payload: any): Promise<any> => {
    try {
        const configBaseUrl:any = process.env.REACT_APP_BASEURL !== undefined ? JSON.parse(process.env.REACT_APP_BASEURL) : {};
        let headers:Headers = {
            "Content-Type": "application/json",
        }
        if (payload.service === "CHATBOT") {
            headers = { ...headers, Authorization: `${payload.authToken.token}` };
        }



        const cancelToken = axios.CancelToken.source();
        const configAxios:any = {
            method: "post", 
            url: payload.service === "CHATBOT" ? payload.url : configBaseUrl.url, 
            headers: headers,    
            data: payload.service === "CHATBOT" ? JSON.stringify(payload.data) : JSON.stringify(payload),
            cancelToken: cancelToken.token,
            timeout: 30000,
            responseType: 'json',
        }
        const response = await axios(configAxios);
        return {
            status: response.status,
            data: response.data
        }
    } catch(err:any) {
        return {
            status: err.status,
            data: err.response
        }
    }
}